// File: src/store/slices/searchSlice.js
// Purpose: Redux Toolkit slice for search functionality
// Last modified: 2025-11-16

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ==================== Async Thunks ====================

/**
 * Search questions
 */
export const searchQuestions = createAsyncThunk(
    'search/searchQuestions',
    async (searchTerm, { rejectWithValue }) => {
        try {
            const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://www.zakovat-savollari.com';
            const response = await fetch(
                `${API_BASE_URL}/api/search?searchTerm=${encodeURIComponent(searchTerm)}`,
                {
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (!response.ok) {
                const error = new Error(`HTTP ${response.status}: ${response.statusText}`);
                error.status = response.status;
                throw error;
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('[searchQuestions] Error:', error);
            return rejectWithValue(error.message || 'Qidiruvda xatolik yuz berdi');
        }
    }
);

// ==================== Slice ====================

const initialState = {
    searchResults: [],
    loading: false,
    error: null,
    lastSearchTerm: '',
};

const searchSlice = createSlice({
    name: 'search',
    initialState,
    reducers: {
        clearSearchResults: (state) => {
            state.searchResults = [];
            state.lastSearchTerm = '';
            state.error = null;
        },
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Search questions
            .addCase(searchQuestions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(searchQuestions.fulfilled, (state, action) => {
                state.loading = false;
                state.searchResults = action.payload;
                state.lastSearchTerm = action.meta.arg;
            })
            .addCase(searchQuestions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.searchResults = [];
            });
    },
});

// ==================== Exports ====================

export const { clearSearchResults, clearError } = searchSlice.actions;

// Selectors
export const selectSearchResults = (state) => state.search.searchResults;
export const selectSearchLoading = (state) => state.search.loading;
export const selectSearchError = (state) => state.search.error;
export const selectLastSearchTerm = (state) => state.search.lastSearchTerm;

export default searchSlice.reducer;
